import React, { useState, useEffect } from "react";
import { getSettings, adminUpdateSettings } from "../services/api";
import AdminLayout from "./AdminLayout";

export default function AdminSettings() {
  const [settings, setSettings] = useState({
    site_name: "HandyCraft Bali",
    contact_email: "hello@handycraft.bali",
    contact_phone: "+62 812-3456-789",
    contact_address: "Jl. Raya Ubud No. 88, Gianyar, Bali",
    whatsapp_number: "628123456789",
    about_text: "Menghadirkan keindahan dan keotentikan seni kerajinan tangan Bali ke seluruh penjuru dunia.",
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const data = await getSettings();
      if (Object.keys(data).length > 0) {
        setSettings((prev) => ({ ...prev, ...data }));
      }
    } catch (err) {
      console.error("Failed to fetch settings", err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await adminUpdateSettings({ settings });
      alert("Pengaturan web berhasil diperbarui");
    } catch (err) {
      alert("Gagal memperbarui pengaturan");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout>
      <div className="section-header" style={{ textAlign: 'left', margin: '0 0 30px' }}>
        <h2 className="section-title">Pengaturan Website</h2>
      </div>

      <div className="auth-card" style={{ maxWidth: '900px', margin: '0' }}>
        <form onSubmit={handleSubmit}>
          <div className="admin-form-grid-2" style={{ gap: '30px' }}>
            <div className="form-group">
              <label className="form-label">Nama Website</label>
              <input
                className="form-input"
                name="site_name"
                value={settings.site_name}
                onChange={handleChange}
                required
              />
            </div>
            
            <div className="form-group">
              <label className="form-label">Nomor WhatsApp (62...)</label>
              <input
                className="form-input"
                name="whatsapp_number"
                value={settings.whatsapp_number}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label className="form-label">Email Kontak</label>
              <input
                className="form-input"
                type="email"
                name="contact_email"
                value={settings.contact_email}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label className="form-label">Telepon Kontak</label>
              <input
                className="form-input"
                name="contact_phone"
                value={settings.contact_phone}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Alamat Kantor</label>
            <input
              className="form-input"
              name="contact_address"
              value={settings.contact_address}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Tentang Kami (Footer Detail)</label>
            <textarea
              className="form-input"
              name="about_text"
              rows="4"
              value={settings.about_text}
              onChange={handleChange}
            />
          </div>

          <button type="submit" className="btn btn-primary" disabled={loading} style={{ marginTop: '20px' }}>
            {loading ? "Menyimpan..." : "Simpan Perubahan"}
          </button>
        </form>
      </div>
    </AdminLayout>
  );
}
